import classNames from "classnames";
import "./AreaReader.scss"

const AreaReader = ({areaType, children}) => {
    return(
        <div className={classNames("area-reader", areaType)}>
            {children}
        </div>
    )
}

export default AreaReader;